import Vue from 'vue'

Vue.directive('focus', {
  inserted (el) {
    el.focus()

    if (el.getAttribute('data-autoheight')) {
      el.style.height = '0px'
      el.style.height = el.scrollHeight + 'px'
    }
  }
})



// WEBPACK FOOTER //
// ./src/modules/directives/Focus.js